import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class FileUploadInputUtilsService {
  static getFileIcon(fileType: string): string {
    if ('application/pdf' === fileType) {
      return 'fa-file-pdf';
    } else if (
      [
        'application/msword',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      ].includes(fileType)
    ) {
      return 'fa-file-word';
    } else if (
      [
        'application/vnd.ms-excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      ].includes(fileType)
    ) {
      return 'fa-file-excel';
    } else if (['image/jpeg', 'image/png'].includes(fileType)) {
      return 'fa-file-image';
    }
    // Agrega más tipos de archivo y sus iconos correspondientes según sea necesario

    return 'fa-file'; // Icono por defecto
  }

  static getAcceptLabel(value: string): string {
    const accept = value.split(',');
    if (accept.length === 1) return accept[0];
    return accept.slice(0, -1).join(', ') + ' o ' + accept.slice(-1);
  }

  static isValidFileType(file: File, accept: string): boolean {
    const acceptedTypes = accept.split(',').map((type) => type.trim());
    return acceptedTypes.some(
      (type) => file.name.endsWith(type) || file.type === type
    );
  }
}
